const data = [
  {
    id: "overview",
    icon: "iconsminds-line-chart-1",
    label: "menu.overview",
    to: "/app/pages/analytics",
    subs: [
      {
        icon: "iconsminds-line-chart-1",
        label: "menu.analytics",
        to: "/app/pages/analytics",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-coins",
        label: "breakeven.title",
        to: "/app/breakeven",
        upgrade: "platinum",
      },
    ],
  },
  {
    id: "sales",
    icon: "iconsminds-shopping-cart",
    label: "menu.sales",
    to: "/app/dashboards/default",
    subs: [
      {
        icon: "iconsminds-shop-4",
        label: "menu.dashboards",
        to: "/app/dashboards/default",
      },
      {
        icon: "iconsminds-printer",
        label: "menu.sales-invoice",
        to: "/app/pages/order",
      },
      {
        icon: "iconsminds-receipt-4",
        label: "menu.einvoice",
        to: "/app/pages/einvoice",
        requiresEInvoice: true,
      },
      {
        icon: "iconsminds-clock-forward",
        label: "menu.shift-session",
        to: "/app/pages/shift-session",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-clock",
        label: "menu.booking",
        to: "/app/pages/booking",
        businessTypes: ["cafe", "restaurant"],
      },
      {
        icon: "simple-icon-grid",
        label: "menu.table-setting",
        to: "/app/pages/table-setting",
        businessTypes: ["cafe", "restaurant"],
      },
      {
        icon: "iconsminds-qr-code",
        label: "menu.qrcode",
        to: "/app/pages/qrcode",
        businessTypes: ["cafe", "restaurant"],
      },
      {
        icon: "simple-icon-present",
        label: "menu.promotion",
        to: "/app/pages/promotion",
      },
      {
        icon: "iconsminds-shopping-bag",
        label: "menu.ecommerce",
        to: "/app/pages/ecommerce",
        upgrade: "pro",
      },
    ],
  },
  {
    id: "inventory",
    icon: "iconsminds-box-full",
    label: "menu.inventory-management",
    to: "/app/pages/product",
    subs: [
      {
        icon: "simple-icon-list",
        label: "menu.thumb-list",
        to: "/app/pages/product",
      },
      {
        icon: "simple-icon-basket",
        label: "menu.stock",
        to: "/app/pages/stock",
      },
      {
        icon: "iconsminds-add-file",
        label: "warehouse.import",
        to: "/app/pages/warehouse-import",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-notepad",
        label: "menu.inventory-audit",
        to: "/app/pages/inventory-audit",
      },
      {
        icon: "iconsminds-remove-file",
        label: "menu.stock-out",
        to: "/app/pages/stock-out",
      },
    ],
  },
  {
    id: "partners",
    icon: "simple-icon-people",
    label: "menu.crm",
    to: "/app/pages/customer",
    subs: [
      {
        icon: "simple-icon-heart",
        label: "analytics.customer",
        to: "/app/pages/customer",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-network",
        label: "analytics.company-provider",
        to: "/app/pages/company-provider",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-building",
        label: "menu.companies",
        to: "/app/pages/companies",
      },
      {
        icon: "simple-icon-people",
        label: "analytics.user-staff",
        to: "/app/pages/user-staff",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-add-user",
        label: "menu.user-role",
        to: "/app/pages/user-role",
      },
      {
        icon: "iconsminds-key-lock",
        label: "menu.role",
        to: "/app/pages/role",
      },
    ],
  },
  {
    id: "finance",
    icon: "iconsminds-financial",
    label: "menu.finance",
    to: "/app/pages/cash-flow",
    subs: [
      {
        icon: "iconsminds-coins",
        label: "analytics.cash-flow",
        to: "/app/pages/cash-flow",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-money-bag",
        label: "analytics.treasury",
        to: "/app/pages/treasury",
        upgrade: "platinum",
      },
      {
        icon: "iconsminds-financial",
        label: "menu.tax-accounting",
        to: "/app/pages/tax-accounting",
        upgrade: "platinum",
      },
    ],
  },
  {
    id: "utilities",
    icon: "iconsminds-speach-bubble-8",
    label: "menu.utilities",
    to: "/app/pages/message",
    subs: [
      {
        icon: "iconsminds-speach-bubble-8",
        label: "menu.message",
        to: "/app/pages/message",
      },
      {
        icon: "iconsminds-calendar-4",
        label: "menu.calendars",
        to: "/app/calendars",
      },
      {
        icon: "iconsminds-check",
        label: "menu.todo",
        to: "/app/pages/todo",
      },
      {
        icon: "iconsminds-file-edit",
        label: "menu.form-dynamic",
        to: "/app/pages/form-dynamic",
      },
    ],
  },
  {
    id: "applications",
    icon: "iconsminds-profile",
    label: "menu.applications",
    to: "/app/applications/profile",
    subs: [
      {
        icon: "iconsminds-profile",
        label: "menu.profile",
        to: "/app/applications/profile",
      },
      {
        icon: "iconsminds-type-pass",
        label: "menu.forgot-password",
        to: "/user/forgot-password",
        denied: true,
      },
      {
        icon: "simple-icon-diamond",
        label: "menu.upgrade",
        to: "/app/applications/upgrade",
        denied: true,
      },
      {
        icon: "simple-icon-settings",
        label: "menu.setting",
        to: "/app/applications/setting",
        denied: true,
      },
    ],
  },
];
export default data;
